export enum FundAllocationsTitles {
    ADD_FUNDS = "You are about to add the total fund allocation for the Ukukhula Bursary fund",
    ADD_FUNDS_TITLE = "Add funds",
    REALLOCATE_FUNDS = "You are about to reallocate funds between universities",
    MOVE_FUNDS = "You are about to move funds between departments",
    PERMISSIONS = "By clicking \"confirm\" you warrant that you are duly authorised to move funds.",
    ADD_TO_TOTAL = "Add to total fund allocation",
    TOTAL_INPUT_SUB = "Please input an amount you would like to add to the fund allocation and then select the universities you would like to split the funds between.",
    TOTAL_FUNDS_ADDED = "Total funds added:",
    SPLIT_FUNDS = "Select universities to split funds between",
    SPLIT_FUNDS_SUB = "Please select the universities you would like to split the added funds equally between.",
    CONFIRM_SPLIT = "Confirm: Add and split funds",
    CONFIRM_SPLIT_SUB = "Confirm the following fund additions and the universities you have allocated them to:",
    REALLOCATE_FUNDS_INPUT = "Reallocate funds:",
    REALLOCATE_FUNDS_INPUT_SUB = "Please select the universities that you would like to transfer funds from and to.",
    REALLOCATION_AMOUNT = "Indicate the amount of funds to reallocate",
    REALLOCATION_AMOUNT_SUB = "Indicate the amount of funds that you would like to reallocate between the following universities:",
    REALLOCATE_AVAILABLE_FUNDS = "Reallocate all available funds",
    CONFIRM_REALLOCATION = "Confirm: Reallocate funds",
    CONFIRM_REALLOCATION_SUB = "Please confirm the reallocation of funds between the following universities.",
    MOVE_FUNDS_INPUT = "Move funds between departments",
    MOVE_FUNDS_INPUT_SUB = "Please select the departments that you would like to move funds from and to.",
    MOVE_FUNDS_AMOUNT = "Indicate the amount of funds to move",
    MOVE_FUNDS_AMOUNT_SUB = "Indicate the amount of funds that you would like to move between the following departments:",
    MOVE_AVAILABLE_FUNDS = "Move all available funds",
    CONFIRM_MOVE = "Confirm: Move funds",
    CONFIRM_MOVE_SUB = "Please confirm the movement of funds between the following departments.",
    ADD_SUCCESS = "Success! The funds have successfully been added",
    ADD_SUCCESS_SUB = "The funds have successfully been allocated between the universities.",
    REALLOCATE_SUCCESS = "Success! The funds have successfully been reallocated",
    REALLOCATE_SUCCESS_SUB = "The funds have successfully been reallocated between the universities.",
    MOVE_SUCCESS = "Success! The funds have successfully been moved",
    MOVE_SUCCESS_SUB = "The funds have successfully been moved between the departments.",
    ALLOCATE = "You are about to allocate funds to a university.",
    ALLOCATE_FUNDS = "Allocate funds:",
    ALLOCATE_FUNDS_SUB = "Please select the university that you would like to allocate funds to.",
    ALLOCATION_AMOUNT = "Indicate the amount of funds to allocate",
    ALLOCATION_AMOUNT_SUB = "Indicate the amount of funds that you would like to allocate to the following university:",
    ALLOCATION_AMOUNT_TITLE = "Allocation amount:",
    CONFIRM_ALLOCATION = "Confirm: Allocate funds",
    CONFIRM_ALLOCATION_SUB = "Please confirm the allocation of funds to the following university.",
    ALLOCATE_SUCCESS = "Success! The funds have successfully been allocated!",
    ALLOCATE_SUCCESS_SUB = "The funds have successfully allocated to ",
    CURRENT_ALLOCATION = "Current allocation:",
    UNALLOCATED_FUNDS = "Unallocated fund amount:",
    SPLIT_FUNDS_ADD = "Would you like to add these funds to the ‘Total fund allocation’ or, allocate and split the funds between universities?",
    ADD_TO_FUND_SUCCESS = "Success! The funds have successfully been added",
    ADD_TO_FUND_SUCCESS_SUB = "The funds have successfully been added to the fund allocation and can be allocated to specific universities later.",
    SELECT_UNIVERSITY = "Select university",
    SELECT_DEPARTMENT = "Select department",
    INPUT_FUNDS = "Input funds",
    FUNDS_TO_ALLOCATE = "Input the amount of funds you would like to allocate",
    TRANSFER_AMOUNT = "Transfer amount:",
    FROM = "From:",
    TO = "To:",
    OLD_ALLOCATION = "Old allocation:",
    NEW_ALLOCATION = "New allocation:",
    AMOUNT = "Amount:"
}
